import React, { useContext } from "react";
import { ShopContext } from '../context/shopContext'
import { useParams } from "react-router-dom";
import Breadcrumb from "../components/breadcrumb/breadcrumb";
import ProductDisplay from "../components/productDisplay/productDisplay";
import DescriptionBox from "../components/descriptionBox/descriptionBox";
import RelatedProducts from "../components/relatedProducts/relatedProducts"


const Product = () => {

    const { allProducts } = useContext(ShopContext);
    const { productId } = useParams();
    const product = allProducts.find((e) => e.id === productId)

    return (
        <div>
            <Breadcrumb product={product} />
            <ProductDisplay product={product} />
            <DescriptionBox product={product} />
            <RelatedProducts product={product} />
        </div>
    )
}

export default Product